import { render, staticRenderFns } from "./addcorpusDialog.vue?vue&type=template&id=df625222&scoped=true&"
import script from "./addcorpusDialog.vue?vue&type=script&lang=js&"
export * from "./addcorpusDialog.vue?vue&type=script&lang=js&"
import style0 from "./addcorpusDialog.vue?vue&type=style&index=0&id=df625222&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df625222",
  null
  
)

export default component.exports